import { SlideModal } from "components/Modal/SlideModal";
import { Container } from "components/SimpleRegistrations/Container";
import { Header } from "components/SimpleRegistrations/Header";
import { Body } from "components/SimpleRegistrations/Body";
import { Footer } from "components/SimpleRegistrations/Footer";
import { LandscapeVisitPurposeSelect } from "~/components/SimpleRegistrations/landscape/VisitPurposeSelect";
import { PortraitVisitPurposeSelect } from "~/components/SimpleRegistrations/portrait/VisitPurposeSelect";
import { useSimpleRegistrationContext } from "~/pages/SimpleRegistrationsPage";

interface VisitPurposeModalProps {
  open: boolean;
  onClose: (selected?: boolean) => void;
}

export const VisitPurposeModal = ({
  open,
  onClose,
}: VisitPurposeModalProps) => {
  const { isLandscape, visitPurpose, reset } = useSimpleRegistrationContext();

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <SlideModal open={open}>
      <Container>
        <Header
          onChangePrevPage={handleClose}
          onClose={handleClose}
          usePageIndicator={false}
          page={1}
          total={1}
        />
        <Body>
          {isLandscape ? (
            <LandscapeVisitPurposeSelect />
          ) : (
            <PortraitVisitPurposeSelect />
          )}
        </Body>
        <Footer
          text="접수하기"
          disabled={!visitPurpose || visitPurpose.length === 0}
          onClick={() => onClose(true)}
        />
      </Container>
    </SlideModal>
  );
};

export default VisitPurposeModal;
